// Scroll to element with delay
function scrollToElement(elementId, delay = 0, offset = 0) {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({   
        top: offsetPosition,
        behavior: 'smooth'
      });
    }  
  }, delay);
}       

// Handle clicks on links to #enrollment_section
document.addEventListener('click', function(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const link = target.closest('a[href*="#enrollment_section"]');
  if (link) {
    event.preventDefault();
    // Get the header-component height (default to 0 if not present)
    let headerHeight = 0;
    const header = document.querySelector('header-component');
    if (header instanceof HTMLElement) {
      headerHeight = header.offsetHeight || 0; 
    }
    scrollToElement('enrollment_section', 100, headerHeight);
  }
});

// Custom filter checkbox synchronization for collection pages
(function() {
  // Only run on collection pages
  const isCollectionPage = document.documentElement.dataset.template && 
    document.documentElement.dataset.template.includes('collection');
  const isCollectionURL = window.location.pathname.includes('/collections/');
  
  if (!isCollectionPage && !isCollectionURL) {
    return;
  }
  
  let isSyncing = false;
  
  function syncCustomToOther(customCheckbox, isChecked) {
    if (isSyncing) {
      return;
    }
    
    isSyncing = true;
    const clickedValue = customCheckbox.value;
    const allCheckboxes = document.querySelectorAll('input[name="filter.v.m.custom.album_cover_type"]:not(.custom-checkbox)');
    
    allCheckboxes.forEach(function(otherCheckbox) {
      if (otherCheckbox.value === clickedValue) {
        if (otherCheckbox.checked !== isChecked) {
          otherCheckbox.checked = isChecked;
          const changeEvent = new Event('change', { bubbles: true, cancelable: true });
          otherCheckbox.dispatchEvent(changeEvent);
        } else {
          const changeEvent = new Event('change', { bubbles: true, cancelable: true });
          otherCheckbox.dispatchEvent(changeEvent);
        }
      }
    });
    
    setTimeout(function() {
      isSyncing = false;
    }, 0);
  }
  
  function syncOtherToCustom(otherCheckbox, isChecked) {
    if (isSyncing) {
      return;
    }
    
    isSyncing = true;
    const clickedValue = otherCheckbox.value;
    const customCheckboxes = document.querySelectorAll('.custom-checkbox');
    
    customCheckboxes.forEach(function(customCheckbox) {
      if (customCheckbox.value === clickedValue) {
        if (customCheckbox.checked !== isChecked) {
          customCheckbox.checked = isChecked;
        }
      }
    });
    
    setTimeout(function() {
      isSyncing = false;
    }, 0);
  }
  
  function initCustomCheckboxes() {
    const customCheckboxes = document.querySelectorAll('.custom-checkbox');
    
    customCheckboxes.forEach(function(customCheckbox) {
      if (!customCheckbox.dataset.syncListenerAdded) {
        customCheckbox.dataset.syncListenerAdded = 'true';
        
        customCheckbox.addEventListener('change', function(event) {
          event.stopImmediatePropagation();
          syncCustomToOther(customCheckbox, customCheckbox.checked);
        }, true);
      }
    });
  }
  
  function initOtherCheckboxes() {
    const allOtherCheckboxes = document.querySelectorAll('input[name="filter.v.m.custom.album_cover_type"]:not(.custom-checkbox)');
    
    allOtherCheckboxes.forEach(function(otherCheckbox) {
      if (!otherCheckbox.dataset.syncListenerAdded) {
        otherCheckbox.dataset.syncListenerAdded = 'true';
        
        otherCheckbox.addEventListener('change', function() {
          syncOtherToCustom(otherCheckbox, otherCheckbox.checked);
        });
      }
    });
  }
  
  function syncInitialState() {
    isSyncing = true;
    
    const allOtherCheckboxes = document.querySelectorAll('input[name="filter.v.m.custom.album_cover_type"]:not(.custom-checkbox)');
    const customCheckboxes = document.querySelectorAll('.custom-checkbox');
    
    // First, uncheck all custom checkboxes that don't have a matching checked other checkbox
    customCheckboxes.forEach(function(customCheckbox) {
      let hasMatchingChecked = false;
      allOtherCheckboxes.forEach(function(otherCheckbox) {
        if (otherCheckbox.value === customCheckbox.value && otherCheckbox.checked) {
          hasMatchingChecked = true;
        }
      });
      if (!hasMatchingChecked && customCheckbox.checked) {
        customCheckbox.checked = false;
      }
    });
    
    // Then, check custom checkboxes that match checked other checkboxes
    allOtherCheckboxes.forEach(function(otherCheckbox) {
      if (otherCheckbox.checked) {
        customCheckboxes.forEach(function(customCheckbox) {
          if (customCheckbox.value === otherCheckbox.value) {
            if (!customCheckbox.checked) {
              customCheckbox.checked = true;
            }
          }
        });
      }
    });
    
    setTimeout(function() {
      isSyncing = false;
    }, 0);
  }
  
  function init() {
    initCustomCheckboxes();
    initOtherCheckboxes();
    setTimeout(function() {
      syncInitialState();
    }, 100);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize when sections are updated
  document.addEventListener('shopify:section:load', function() {
    init();
    setTimeout(syncInitialState, 200);
  });
  
  document.addEventListener('shopify:section:reorder', function() {
    init();
    setTimeout(syncInitialState, 200);
  });
  
  // Watch for dynamically added checkboxes
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.matches && (node.matches('.custom-checkbox') || node.matches('input[name="filter.v.m.custom.album_cover_type"]'))) {
              shouldReinit = true;
            }
            if (node.querySelectorAll && (node.querySelectorAll('.custom-checkbox').length || node.querySelectorAll('input[name="filter.v.m.custom.album_cover_type"]').length)) {
              shouldReinit = true;
            }
          }
        });
      }
    });
    if (shouldReinit) {
      setTimeout(function() {
        init();
        syncInitialState();
      }, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();